import { render } from "./ElectionThankYouView.vue?vue&type=template&id=68685f87"
import script from "./ElectionThankYouView.vue?vue&type=script&lang=js"
export * from "./ElectionThankYouView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__